<template>
  <div class="flex flex-col gap-sm rounded bg-avtalat-gray p-sm">
    <h4 class="font-bold" v-if="heading">{{ heading }}</h4>
    <slot></slot>
  </div>
</template>
<script setup lang="ts">
export type ArendeSectionProps = {
  heading?: string;
};

defineProps<ArendeSectionProps>();
</script>
